import $ from 'jquery';
import Preloader from './Preloader';

export function initShowMore ($elements) {
	$elements.each((i, el) => {
		const $el = $(el);
		showMore($el);
	});
}

function showMore ($element) {
	const $container = $element.find('[data-container]');
	const $button = $element.find('[data-button]');
	const { count, url, alias, count_click } = $button.data('button'); // eslint-disable-line camelcase
	const preloader = new Preloader($element);

	$button.on('click', (e) => {
		e.preventDefault();
		if (count && url) {
			$.ajax({
				type: 'GET',
				url: url,
				contentType: 'application/json',
				data: {
					count: count,
					alias: alias,
					count_click: count_click // eslint-disable-line camelcase
				},
				beforeSend: function () {
					preloader.show();
					$('.old_btn_show').hide();
				}
			}).done((resp) => {
				preloader.hide();
				if (resp) {
					$container.html(resp.html);
					if (resp.noMore) {
						$button.remove();
					}
				}
			});
		}
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/show-more.js